import { Facilities, FacilityEventType, Icons, useAuth } from "@app/shared";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Pages } from "..";
import { useFetch } from "../../../hooks";
import { DashboardLayout } from "../../layouts";
import { IconLink, SkeletonGrid } from "../../shared";
import { OrganizationDropdown } from "../../shared/OrganizationDropdown";
import { MappedFacilityEvent, OrganizationEventsTable } from "./OrganizationEventsTable";
import { RequiresGoogleMaps } from "../../shared/maps/RequiresGoogleMaps";
import { FilterOption } from "../../shared/Filter";

export const OrganizationEvents: FC = () => {
    const { user, currentOrganizationId, setCurrentOrganizationId } = useAuth();
    const [facilities, , facilitiesHelpers] = useFetch(() => (currentOrganizationId ? Facilities.getActiveByOrganizationId(currentOrganizationId) : Promise.resolve([])), [currentOrganizationId]);
    const navigate = useNavigate();
    const [showReportLink, setShowReportLink] = useState(false);
    const changeOrgs = async (newOrgId: string) => {
        setCurrentOrganizationId(newOrgId);
    };

    useEffect(() => {
        if (!user) return;
        if (!currentOrganizationId) {
            navigate(Pages.AddOrganization.getUrl());
        }
    }, [user, navigate, currentOrganizationId]);

    if (facilitiesHelpers.isLoading || facilitiesHelpers.isLoading === undefined) {
        return (
            <DashboardLayout centerChildren={"Loading..."}>
                <SkeletonGrid rows={3} cols={1} />
            </DashboardLayout>
        );
    }

    if (!currentOrganizationId) {
        return <></>;
    }

    const handleFilterChange = (f: FilterOption<MappedFacilityEvent>[]) => {
        setShowReportLink(f.find(x => x.id === 'eventType')?.value === FacilityEventType.ScreenLineChange+'')
    }

    return (
        <DashboardLayout leftChildren={<OrganizationDropdown onChange={changeOrgs} initOrgId={currentOrganizationId} />} centerChildren="Organization Events" rightChildren={showReportLink && <IconLink Icon={Icons.Chart} onClick={e => navigate(Pages.EventReports.getUrl(), { state: { facilities: facilities } })}>Reports</IconLink>}>
            <RequiresGoogleMaps>
                <OrganizationEventsTable organizationId={currentOrganizationId} facilities={facilities || []} onChange={handleFilterChange} />
            </RequiresGoogleMaps>
        </DashboardLayout>
    );
};
